export const loadingIndicatorStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
};
